import React from 'react';

import { OnClick } from '@rbilabs/components-library';

import { useSelectedReward } from 'components/app-header/loyalty/rewards-management/hooks';
import { ScanAndPayProvider } from 'components/th-scan-and-pay/state/provider';
import { useLoyaltyActiveCard } from 'hooks/loyalty';
import useEffectOnce from 'hooks/use-effect-once';
import { TimsRewardsPoints } from 'pages/account/tims-rewards/shared-onboarding-modal-components/tims-rewards-points';
import { RewardsDropdown } from 'pages/cart/cart-reward-dropdown';
import { useCustomizableContent } from 'state/customizable-content';

import RewardsUnavailable from '../rewards-unavailable';
import { ContentBlock } from '../styled';

import {
  PhysicalCardContentSection,
  ScanQRContent,
  ScanRewardsManagement,
  ScanScanAndPay,
} from './components';
import { RewardsWrapper } from './scan-rewards.styled';

interface LoyaltyRewards {
  onDismiss: OnClick;
}

export const ScanRewards: React.FC<LoyaltyRewards> = ({ onDismiss }): JSX.Element => {
  const { loyaltyDetails, activeCard, loading } = useLoyaltyActiveCard();
  const { requestLoyaltyCustomizableContent } = useCustomizableContent();
  const { onChangeRewardTier, updatingRewardTier } = useSelectedReward();

  useEffectOnce(requestLoyaltyCustomizableContent);

  return (
    <ScanAndPayProvider>
      <RewardsWrapper>
        <RewardsUnavailable />
        <ContentBlock margin="0">
          <TimsRewardsPoints points={loyaltyDetails?.points ?? 0} />
          <RewardsDropdown
            radioButtonName="scan-page-rewards-dropdown-reward-tier"
            setSelectedRewardsTier={onChangeRewardTier}
            showHeader={false}
          />
        </ContentBlock>
        <ScanQRContent loading={loading} loadingTier={updatingRewardTier} activeCard={activeCard} />
        <ScanRewardsManagement />
        <ScanScanAndPay />
        <PhysicalCardContentSection onDismiss={onDismiss} />
      </RewardsWrapper>
    </ScanAndPayProvider>
  );
};

export default ScanRewards;
